import React from 'react'

import { Box, TextField, Toolbar, IconButton, Tooltip } from '@mui/material'
import { Close, Search } from '@mui/icons-material'

interface Props {
    isFiltered?: boolean
    placeholder?: string
    searchParams?: string
    onChangeFilter?: (event: React.ChangeEvent<HTMLInputElement>) => void
    onClickClear?: () => void
    handleSubmit?: (event: React.SyntheticEvent) => void
}

const GlobalFilter: React.FC<Props> = ({
    isFiltered,
    placeholder,
    searchParams,
    onChangeFilter,
    onClickClear,
    handleSubmit,
}: Props) => {
    return (
        <Toolbar disableGutters variant="dense">
            <Box
                sx={{
                    textAlign: { xs: 'center', sm: 'right' },
                    mx: { xs: 1, sm: '0' },
                    flex: 1,
                }}
                onSubmit={handleSubmit}
            >
                <TextField
                    sx={{
                        marginRight: { xs: 3, sm: 0 },
                        width: { xs: '100%', sm: '350px' },
                    }}
                    label={isFiltered ? 'Filtered by' : 'Filter'}
                    size="small"
                    variant="outlined"
                    value={searchParams || ''}
                    onChange={onChangeFilter}
                    placeholder={placeholder}
                    InputProps={{
                        startAdornment: searchParams ? (
                            <Tooltip title="Clear filter">
                                <IconButton color="primary" size="small" onClick={onClickClear}>
                                    <Close />
                                </IconButton>
                            </Tooltip>
                        ) : undefined,
                        endAdornment: (
                            <Tooltip title="Search">
                                <IconButton
                                    color={searchParams?.length ? 'primary' : 'default'}
                                    size="small"
                                    onClick={handleSubmit}
                                >
                                    <Search />
                                </IconButton>
                            </Tooltip>
                        ),
                    }}
                />
            </Box>
        </Toolbar>
    )
}
export default GlobalFilter
